import React, { FC } from 'react'
import styles from './CompanyCardMainInformation.module.css'
import iconEdit from '../../assets/icons/iconEdit.svg'
import PATH from '../../navigation/path'
import { useNavigate, useParams } from 'react-router-dom'
import { CompaniesType } from '../../redux/actions/types'
import { createRoleCompanyFromEnToRu } from '../../utils/createRoleForRegister'
import { useAppSelector } from '../../redux/types/types'
import CustomButton from '../UI/CustomButton/CustomButton'
import { ItemInfo } from '../ItemInfo/ItemInfo'

export type CompanyCardMainInformationPropsType = {
  companyData: CompaniesType
}

const CompanyCardMainInformation: FC<CompanyCardMainInformationPropsType> = ({ companyData }) => {
  const { companyId } = useParams<{ companyId: string }>()

  const { userRole, user } = useAppSelector((state) => state.auth)

  const navigate = useNavigate()

  const onRedirectToEditCardPage = () => {
    navigate(`${PATH.editCompanyCardPage}${companyId}`)
  }

  const foundObject = companyData.employees.find((item) => item.id === user.employee?.id)

  return (
    <div className={styles.mainInformationBlock}>
      <div className={styles.header}>
        <h2 className={styles.title}>Основная информация</h2>
        {(userRole === 'superAdmin' ||
          userRole === 'admin' ||
          (userRole === 'directorPlace' && foundObject) ||
          (userRole === 'directorAgent' && foundObject)) && (
          <CustomButton
            iconSrc={iconEdit}
            className={styles.btn}
            title={''}
            onClick={onRedirectToEditCardPage}
          />
        )}
      </div>
      <div className={styles.mainInformationContainer}>
        <ItemInfo title='Название организации' value={companyData.name} />
        <ItemInfo title='ИНН' value={companyData.inn} />
        <ItemInfo title='Роль' value={createRoleCompanyFromEnToRu(companyData.role) ?? ''} />
        <ItemInfo title='Город' value={companyData.city} />
        <ItemInfo title='Адрес' value={companyData.address} />
        <ItemInfo title='ФИО контактного лица' value={companyData.contactFullName} />
        <ItemInfo title='Телефон контактного лица' value={companyData.contactPhone} />
        <ItemInfo title='Электронная почта' value={companyData.email} />
      </div>
    </div>
  )
}

export default CompanyCardMainInformation
